<template>
    <div :style="{'height' : domHeight +'px' }">
        <div name="query-sort-block" :class="showExport ? 'pr50' : ''">
            <swb-query-sort-area ref="query_sort_area" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler" :eventHandler="queryEventHanlder"></swb-query-sort-area>
        </div>
        <div name="toolbar" class="simple-row">
            <div class="left">
                <span v-if="comInfo.id != null">当前公司：{{comInfo.name || '无'}}</span>
            </div>
            <div class="right">
                <img v-if="!hasTabFlag && showExport" v-resc-url="'/image/excel-ex.png'" style="position:absolute;top:89px;right:10px;border-radius:4px;" height="36" width="36" @click="exportExcel" title="导出Excel"/>
                <img v-if="hasTabFlag && showExport" v-resc-url="'/image/excel-ex.png'" style="position:absolute;top:89px;right:10px;border-radius:4px;" height="36" width="36" @click="exportExcel" title="导出Excel"/>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="configAuto" :needPager="true" :pageSizeList="pageSizes" :rowNoShow="false" :height="tableHeight" :minColWidth="minColWidth" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :multiSelect="multiSelect"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, H5file, Jqext, Store, EventBus, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, showPageRangeSelDlg, Routes, getComnMerchantBizTag } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { showGrpDownloadDlg } from '../ctrl/dialog'
    import { loadRetailerDevcGroupCascList } from '../retailer/asset-comn'
    import SwbResultTable from '../query/ResultTable'
    Vue.regist(SwbResultTable);
    //报表专用事件总线
    const reportEventBus = EventBus.get("report-events");
    const repeatChecker = Utils.repeatChecker;
    //全局报表单元格链接函数
    window.showReportDetail = function (dataMap, reportCode, colName) {
        if(repeatChecker.isValidFor("showReportDetail", 500)) {
            //防止快速连续点击
            //
            reportEventBus.trigger("cell-click", {
                dataMap: dataMap,
                reportCode: reportCode,
                colName: colName
            });
        }
    };

    import userApi from '../../api/user'
    import easyReportApi from '../../api/easyReport'

    let bizTagObj = null;
    export default {
        name: 'swb-easy-report-table',
        desc: '报表',
        /*
         reportName: 报表名称
         reportCode: 报表自定义代码
         paramMap: 报表隐藏参数默认值 ps: {retailerId: 259, shopId: 71}
         hideParamKeys：报表隐藏参数 数组：ps: ["retailerId", "shopId"]
         */
        // props: ['reportName', 'reportCode', 'paramMap', 'hideParamKeys', 'comInfo'],
        props: {
            confKey: {//自定义配置加载/保存key
                type: String
            },
            configAuto: {//是否根据confKey自动获取元数据配置
                type: Boolean,
                default: false
            },
            reportName: {
                type: String,
                default: null
            },
            reportCode: {
                type: String,
                default: null
            },
            paramMap: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            paramKeys: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            hideParamKeys: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            retailerRealComIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            comInfo: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            includeSubComs: {
                type: Boolean,
                default: false
            },
            detailComponentUrl: { // 需要跳转的详情的url
                type: String,
                default: null
            },
            showStatColumns: {
                type: Boolean,
                default: true
            },
            queryData: {
                type: Boolean,
                default: false
            },
            hasTabFlag: {
                type: Boolean,
                default: false
            },
            showResultColConf: {
                type: Boolean,
                default: true
            },
            defaultSortItems: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            querySortItems: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            domHeight: {
                default: 'auto'
            },
            //操作列
            btnColName: {//操作列名称（若为空则不显示操作列）
                type: String,
                default: null
            },
            btnColWidth: {//操作列宽度
                type: Number,
                default: 100
            },
            btnColTitle: {//操作列标题
                type: String,
                default: '操作'
            },
            btnColFixed: {//操作列是否固定
                type: Boolean,
                default: false
            },
            actionsRenderFuncs: {
                type: Function,
                default: null
            },
            actionsHandlerFuncs: {
                type: Function,
                default: null
            },
            showExport: {
                type: Boolean,
                default: true
            },
            multiSelect: {//是否支持多选
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                //
                pageNumber: 1,
                total: 1,
                pageSize: null,
                pageSizes: [100, 200, 300, 500, 1000],
                //
                reportInfo: {},
                //
                queryConfig: {},
                queryKey: null,
                queryModel: {
                    filterItems: {},
                },
                firstSort: true,
                //
                currentParams: {},
                currentDate: new Date(),
                //
                cacheKey: null,
                queryFlag: false,
                //
                tableHeight: 'auto', //表格高度
                minColWidth: 160,
                resultColConf: null,
                exportParams: {},
                bizTagMap: {},
                sortFlag: false
            }
        },
        watch: {
            reportCode(newVal, oldVal){
                if(newVal != oldVal) {
                    //
                    this.reportInfo = {};
                    this.queryConfig = {};
                    this.queryKey = null;
                    this.queryModel = {
                        filterItems: {},
                        sortItemList: []
                    };
                    this.cacheKey = null;
                    this.resultColConf = null;
                    this.exportParams = {};
                    //
                    this.getCurrentUserInfo();
                    this.renderTable([], 0);
                }
            },
            comInfo(newVal, oldVal){
                if(newVal != oldVal) {
                    //
                    this.getEasyReportTableHtml();
                }
            }
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], [name="toolbar"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            bizTagObj = getComnMerchantBizTag();
            let self = this;
            let bizAspect = getEnumInfoWith('retailerBizAspect', 'name', 'WorkVoucher').value;
            bizTagObj.loadBizTagListByBizAspect(bizAspect, function (bizTagList) {
                let bizTagMap = {};
                bizTagList.forEach(function (item) {
                    bizTagMap[item.id] = item.name;
                });
                self.bizTagMap = Utils.merge({}, bizTagMap);
            }, true);
            //注册事件监听函数
            reportEventBus.bind(
                "cell-click",
                this.handleReportCellClick,
                this,
                "这是" + Vue.$getClassInfo(this).name
            );
            //
            this.currentParams = Utils.merge({}, this.paramMap);
            this.queryFlag = this.queryData;
            if(Utils.isTrue(this.showResultColConf)) {

            }
            this.getCurrentUserInfo();
        },
        beforeDestroy() {
            //注销事件监听函数
            reportEventBus.unbind("cell-click", this.handleReportCellClick);
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable () {
                let self = this;
                let query_sort_area = this.$refs['query_sort_area'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_sort_area);
                //
                resultTable.initMeta({
                    'bizTag': function (row, colName, colValue, rowIndex, colConf) {
                        if(!Utils.isNoB(row.bizTag)) {
                            let bizTag = row.bizTag;
                            let tagIdList = [];
                            if(!Utils.isNoB(bizTag)) {
                                if(bizTag.indexOf("|") >= 0) {
                                    bizTag = bizTag.substring(1, bizTag.length - 1);
                                    tagIdList = bizTag.split("|") || [];
                                } else {
                                    return '<span class="swb-tags swb-tags-success mr5">' + bizTag + '</span>';
                                }
                            }
                            let html = '';
                            for(let i = 0; i < tagIdList.length; i++) {
                                let tagId = parseInt(tagIdList[i]);
                                let tagName = bizTagObj.getBizTagNameById(tagId);
                                if(tagName != null) {
                                    html += '<span class="swb-tags swb-tags-success mr5">' + tagName + '</span>';
                                }
                            }
                            return html;
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        if(self.actionsRenderFuncs) {
                            return self.actionsRenderFuncs(row, colName, colValue, rowIndex);
                        }
                        if(true) {
                            return '<a name="view" class="swb-btn swb-btn-link">详情</a>';
                        }
                    }
                }, {
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(self.actionsHandlerFuncs) {
                            self.actionsHandlerFuncs(row, colName, colValue, rowIndex, btnName);
                        }
                        if(btnName == 'view') {
                            self.toViewDetail(row);
                        }
                    }
                });
            },
            getCurrentUserInfo: function () {
                let self = this;
                let theLoad = MsgBox.loading();
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity;
                        //
                        let currentParams = self.currentParams;
                        currentParams.retailerId = scopeEntity.id;
                        currentParams.cxtMerchantId = scopeEntity.id;
                        currentParams.cxtMerchantIdX = scopeEntity.id;
                        currentParams.comId = scopeEntity.comId;
                        currentParams.comLevel = scopeEntity.comLevel;
                        self.currentParams = Utils.merge({}, currentParams);
                        self.cacheKey = self.reportCode + '_' + scopeEntity.id;
                        //
                        self.fetchReportInitParams();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            queryHandler(queryModel){
                this.queryModel = queryModel;
                this.pageNumber = 1;
                //
                this.getEasyReportTableHtml();
            },
            queryEventHanlder(itemCode, eventName, itemValue, filterItems, cascFields) {
                console.log(itemCode + " @" + eventName + " = " + itemValue);
                if(eventName == 'change') {
                    //
                    if(!Utils.isNoB(itemCode) && !Utils.isNoB(itemValue)) {
                        if(!Utils.isNoB(cascFields) && cascFields.length > 0) {
                            if(typeof cascFields == 'string') {//模板字符串
                            } else {
                                //
                                for(let i = 0; i < cascFields.length; i++) {
                                    let cascName = cascFields[i];
                                    // TODO
                                }
                            }
                        }
                    }
                }
            },
            // 获取初始参数
            fetchReportInitParams: function () {
                let self = this;
                let postData = {
                    reportCode: this.reportCode,
                    paramMap: this.currentParams
                };
                let theLoad = MsgBox.loading();
                easyReportApi.fetchReportInitParamsX(postData, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        //
                        let resultData = result.data;
                        //
                        let initExtra = resultData.initExtra;
                        let statColumns = initExtra.statColumns || [];
                        // 初始参数
                        let initParams = resultData.initParams;
                        let queryData = Utils.merge({}, self.makeParams(initParams, statColumns));
                        let filterItems = queryData.filterItems;
                        let searchConfigData = queryData.searchConfigData || null;
                        if(Utils.isNoB(searchConfigData)) {
                            searchConfigData = {};
                            searchConfigData.queryFields = [];
                        }
                        let queryConfigMap = searchConfigData.queryFields.toMap("code");
                        let deprMonthItem = queryConfigMap['deprMonth'];
                        if(!Utils.isNoB(deprMonthItem) && deprMonthItem.code == 'deprMonth') {
                            deprMonthItem.value = parseInt(new Date().format('yyyyMM'));
                        }
                        //
                        self.queryConfig = searchConfigData;
                        // 添加隐藏参数
                        self.addHideParams(filterItems);
                        self.queryModel.filterItems = Utils.merge({}, filterItems);
                        //
                        if(Utils.isTrue(self.queryFlag)) {
                            self.getEasyReportTableHtml();
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 添加隐藏参数
            addHideParams: function (filterItems) {
                let hideParamKeys = this.hideParamKeys || [];
                let currentParams = this.currentParams;
                for(let i = 0; i < hideParamKeys.length; i++) {
                    let param = hideParamKeys[i];
                    filterItems[param] = currentParams[param];
                }
            },
            // 获取列数据信息
            getMetaColList: function () {
                let self = this;
                let postData = {
                    reportCode: self.reportCode
                };
                easyReportApi.getReportMetaColList(postData, function (result, jqXhr) {
                    if(result.type == 'info') {
                        //
                        let metaColList = result.data || [];
                        console.log(self.reportName);
                        console.log("===========列数据===========");
                        console.log(JSON.encode(metaColList));
                        console.log("===========列数===========");
                        console.log(metaColList.length);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 分页切换
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);

                let resultTable = this.$refs.result_table;
                console.log(resultTable.getPagination());

                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getEasyReportTableHtml();
            },
            getEasyReportTableHtml: function () {
                let self = this;
                let sortItemList = Utils.merge([], self.queryModel.sortItemList);
                let sortItems = self.defaultSortItems || [];
                if(Utils.isTrue(self.firstSort) && !Utils.isNoB(sortItems) && sortItems.length > 0 && Utils.isFalse(self.sortFlag)) {
                    self.firstSort = false;
                    if(!Utils.isNoB(sortItemList) && sortItemList.length > 0) {
                        self.sortFlag = true;
                        for(let i = 0; i < sortItemList.length; i++) {
                            let sortItem = sortItemList[i];
                            if(!sortItems.contains(sortItem)) {
                                sortItems.add(sortItem);
                            }
                        }
                    }
                } else {
                    sortItems = sortItemList;
                }
                let filterItems = self.makePostDataParams();
                filterItems.comId = self.comInfo.id;
                filterItems.comLevel = self.comInfo.level;
                filterItems.includeSubComs = self.includeSubComs;
                if(!Utils.isNoB(self.retailerRealComIds) && self.retailerRealComIds.length > 0) {
                    filterItems.retailerRealComIds = self.retailerRealComIds;
                } else {
                    if(self.reportCode == 'asset_depr_result_report') {
                        MsgBox.warning("请选择实体公司！");
                        return;
                    }
                }
                filterItems.show_dataLinks = self.paramMap.show_dataLinks || false;
                filterItems.page_no = self.pageNumber;
                filterItems.page_size = self.pageSize;
                filterItems.sort_items = sortItems;
                let postData = {
                    reportCode: this.reportCode,
                    paramMap: filterItems
                };
                self.exportParams = filterItems;
                let theLoading = MsgBox.loading();
                easyReportApi.getReportResultDatas(postData, function (result, jqXhr) {
                    theLoading.hide();
                    if(result.type == 'info') {
                        //取消双击行背景着色
                        $(".easyreport tbody > tr").unbind('dblclick');
                        //
                        let reportInfo = result.data;
                        self.reportInfo = Utils.merge({}, reportInfo);
                        self.renderTable(reportInfo.rows, reportInfo.total);
                        //
                        self.total = reportInfo.total;
                        //设置双击行背景着色
                        setTimeout(
                            function () {
                                $(".easyreport tbody > tr").bind('dblclick', function () {
                                    $(this).toggleClass('selected');
                                });
                            }
                            , 1000);

                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 渲染数据
            renderTable(rows, total) {
                //let resultColConfCmp = this.$refs['result_col_conf'];
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                // let confColList = resultColConfCmp.getMetaColList();
                //resultTable.initMeta(confColList);
                let dataMap = {
                    pagination: {
                        totalCount: total,
                        pageNumber: this.pageNumber
                    },
                    rows: rows
                };
                //设置新数据
                resultTable.render(dataMap);
            },
            // 提交参数
            makePostDataParams: function () {
                //
                let filterItems = this.queryModel.filterItems;
                this.addHideParams(filterItems);
                return filterItems;
            },
            //
            makeParams: function (queryFields, statColumns) {
                let self = this;
                let paramKeys = this.paramKeys || [];
                // 跳转详情需要的参数
                let groupName = this.paramMap.groupName || null;
                let servcCatName = this.paramMap.servcCatName || null;
                //
                let searchConfigData = null;
                let filterItems = {};   // 默认参数
                if(!Utils.isNoB(queryFields) && queryFields.length > 0) {
                    let newQueryFields = [];
                    for(let i = 0; i < queryFields.length; i++) {
                        let queryField = queryFields[i];
                        //
                        let required = queryField.required || false;
                        let defValue = queryField.defValue;
                        if(paramKeys.contains(queryField.name)) {
                            defValue = this.paramMap[queryField.name];
                        }
                        filterItems[queryField.name] = defValue;
                        //
                        let newField = {};
                        let dataType = queryField.dataType;
                        if(dataType == 'date') {
                            //
                            newField = this.getQueryFieldItem("Date", "String", queryField.text, queryField.name, defValue, true, null, required);
                        } else if(dataType == 'integer' || dataType == 'string') {
                            //
                            let valueType = dataType == 'integer' ? 'Integer' : 'String';
                            //
                            let dataList = queryField.options || [];
                            let noneVal = dataList.length == 0 ? true : false;
                            switch(queryField.ctrlType) {
                                case "select":
                                    if(Utils.isTrue(noneVal)) {
                                        defValue = null;
                                    }
                                    if(Utils.isNoB(defValue) && required) {
                                        defValue = defValue == null ? dataList[0].value : defValue;
                                    }
                                    defValue = defValue == null ? '' : defValue;
                                    let options = [];
                                    let values = [];
                                    for(let o = 0; o < dataList.length; o++) {
                                        let dataObj = dataList[o];
                                        let dataTemp = {};
                                        if(!Utils.isNoB(dataObj.name)) {
                                            let nameVal = dataObj.name;
                                            if(Utils.isNaturalStr(nameVal)) {
                                                nameVal = parseInt(nameVal);
                                            }
                                            values.add(nameVal);
                                            //
                                            dataTemp.name = nameVal;
                                            dataTemp.text = dataObj.text;
                                            options.push(dataTemp);
                                        }
                                        if(!Utils.isNoB(dataObj.value)) {
                                            let optVal = dataObj.value;
                                            if(Utils.isNaturalStr(optVal)) {
                                                optVal = parseInt(optVal);
                                            }
                                            values.add(optVal);
                                            //
                                            dataTemp.value = optVal;
                                            dataTemp.text = dataObj.text;
                                            options.push(dataTemp);
                                        }
                                    }
                                    if(!Utils.isNoB(defValue) && !values.contains(defValue)) {
                                        defValue = values[0];
                                    }
                                    if(Utils.isNaturalStr(defValue)) {
                                        defValue = parseInt(defValue);
                                    }
                                    filterItems[queryField.name] = defValue;
                                    newField = this.getQueryFieldItem("Select", valueType, queryField.text, queryField.name, defValue,//
                                        true, false, options, "text", "value", queryField.cascName, required);
                                    break;
                                case "selectMul":
                                    defValue = noneVal ? [] : [dataList[0].name];
                                    if(queryField.name == 'groupIds' && !Utils.isNoB(groupName)) {
                                        for(let g = 0; g < dataList.length; g++) {
                                            let dataInfo = dataList[g];
                                            if(groupName == dataInfo.text) {
                                                defValue = [];
                                                defValue.push(dataInfo.name);
                                                break;
                                            }
                                        }
                                    } else if(queryField.name == 'catIds' && !Utils.isNoB(servcCatName)) {
                                        for(let g = 0; g < dataList.length; g++) {
                                            let dataInfo = dataList[g];
                                            if(servcCatName == dataInfo.text) {
                                                defValue = [];
                                                defValue.push(dataInfo.name);
                                                break;
                                            }
                                        }
                                    }
                                    filterItems[queryField.name] = defValue;
                                    if(queryField.name == 'groupIds') {
                                        loadRetailerDevcGroupCascList(function (list) {
                                            dataList = list;
                                            newField = self.getQueryFieldItem("Casc", valueType, queryField.text, queryField.name, defValue,//
                                                true, true, dataList, "text", "name", queryField.cascName, required);
                                        });
                                    } else {
                                        newField = this.getQueryFieldItem("Select", valueType, queryField.text, queryField.name, defValue,//
                                            true, true, dataList, "text", "name", queryField.cascName, required);
                                    }
                                    break;
                                default:
                                    if(!this.hideParamKeys.contains(queryField.name)) {
                                        if(queryField.name == 'useMonth') {
                                            newField = this.getQueryFieldItem("Num", valueType, queryField.text, queryField.name, defValue, true, null, required);
                                        } else {
                                            newField = this.getQueryFieldItem("Text", valueType, queryField.text, queryField.name, defValue, true, null, required);
                                        }
                                    }
                            }
                        } else if(dataType == 'bool' || dataType == 'boolean') {
                            newField = this.getQueryFieldItem("Checkbox", "Boolean", queryField.text, queryField.name, Utils.isTrue(defValue), true, null, required);
                        }
                        //
                        if(!Utils.isNoB(newField.type)) {
                            newQueryFields.push(newField);
                        }
                    }
                    searchConfigData = searchConfigData == null ? {} : searchConfigData;
                    searchConfigData.queryFields = newQueryFields;
                }
                let sortFields = [];
                if(!Utils.isNoB(statColumns) && statColumns.length > 0) {
                    sortFields = this.makeSortFields(statColumns) || [];
                }
                //
                if(!Utils.isNoB(this.querySortItems) && this.querySortItems.length > 0) {
                    let codeList = sortFields.pluck("code") || [];
                    for(let i = 0; i < this.querySortItems.length; i++) {
                        let sortItem = this.querySortItems[i];
                        if(!codeList.contains(sortItem.code)) {
                            sortFields.add(sortItem);
                        }
                    }
                }
                //
                searchConfigData = searchConfigData == null ? {} : searchConfigData;
                searchConfigData.sortFields = sortFields;
                let result = {
                    filterItems: filterItems,
                    searchConfigData: searchConfigData
                };
                return result;
            },
            // 条件查询项
            getQueryFieldItem: function (type, valueType, label, code, value, basic, multiple, dataList, dataLabel, dataValue, cascName, required) {
                let newField = {};
                newField.type = type;
                newField.valueType = valueType;
                newField.label = label;
                newField.code = code;
                newField.value = value;
                newField.basic = basic;
                //
                if(Utils.isTrue(multiple)) {
                    newField.multiple = multiple;
                }
                if(type == "Select") {
                    newField.firstOnClear = required;
                    newField.dataLabel = dataLabel;
                    newField.dataValue = dataValue;
                    newField.cascName = cascName;
                    if(!Utils.isTrue(multiple) && dataList.length > 0) {
                        for(let i = 0; i < dataList.length; i++) {
                            let data = dataList[i];
                            if(Utils.isNoB(data.name)) {
                                break;
                            }
                            data.value = data.name;
                        }
                    } else {
                        if(code == 'tagId') {
                            newField.filterable = true;
                        }
                    }
                    //
                    newField.dataList = dataList;
                } else if(type == "Casc") {
                    newField.collapseTags = true;
                    newField.dataList = dataList;
                }
                return newField;
            },
            // 排序项
            makeSortFields: function (statColumns) {
                let sortFields = [];
                if(!Utils.isNoB(statColumns) && statColumns.length > 0) {
                    for(let i = 0; i < statColumns.length; i++) {
                        let statColumn = statColumns[i];
                        if(statColumn.text == '标识') {
                            continue;
                        }
                        let enabled = true;
                        if(i > 3) {
                            enabled = false;
                        }
                        let sortField = {
                            label: statColumn.text,
                            code: statColumn.name,
                            order: "desc",
                            enabled: enabled
                        };
                        sortFields.add(sortField);
                    }
                }
                return sortFields;
            },
            exportExcel: function () {
                let self = this;
                let pageSize = 5000;
                let pages = Math.ceil(this.total / pageSize);
                if(pages > 10) {
                    showPageRangeSelDlg("选择导出文件序号", pages, 10, this.lastPageNumber, function (ok, range) {
                        if(ok) {
                            if(range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize);
                }
            },
            exportPrintData(pageSize, fromPages, toPages){

                let pages = Math.ceil(this.total / pageSize);
                //
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                let tableData = this.getTableData(pages, pageSize);
                //
                let url = getAppUrl("/file/export/as/excel");
                let downloadUrls = [];
                for(let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = this.reportName + (pages == 1 ? '' : ("_" + (i)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.rowsSrc.data.paramMap.page_no = i;
                    data.fileName = tmpFile.fileName;
                    data.easyReport = true;
                    //
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                let title = this.reportName + '-下载 | 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title, downloadUrls);
            },
            getTableData(pages, pageSize){
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                //
                let exportParams = this.exportParams;
                exportParams.page_size = pageSize;
                let postData = {
                    reportCode: this.reportCode,
                    paramMap: this.exportParams,
                    exportFlag: true,
                    tagMap: this.bizTagMap
                };
                let rowsSrc = {};
                rowsSrc.data = postData;
                rowsSrc.url = "/report/result/datas/get";
                tableData.rowsSrc = rowsSrc;
                //
                return tableData;
            },

            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            // 单元格跳转时间回调
            handleReportCellClick(eventName, eventData) {
                console.log(eventData);
                //
                let {dataMap, reportCode, colName} = eventData;
                if(!Utils.isNoB(dataMap)) {
                    let colValue = dataMap[colName];
                    if(Utils.isNoB(colValue) || colValue <= 0) {
                        return;
                    }
                }
                // 具体逻辑
                let detailComponentUrl = this.detailComponentUrl;
                if(Utils.isNoB(detailComponentUrl)) {
                    MsgBox.warning("请确定要跳转的详情的url");
                    return;
                }
                //
                let filterItems = this.queryModel.filterItems || {};
                if(this.reportCode == 'brand_fulfill_report' || this.reportCode == 'cat_brand_fulfill_report') {
                    let parmas = {
                        catName: dataMap.catName || null,
                        brandName: dataMap.brandName || null,
                        groupId: dataMap.groupId || null,
                        useMonth: filterItems.useMonth || null,
                        createTimeStart: filterItems.createTimeStart || null,
                        createTimeEnd: filterItems.createTimeEnd || null,
                        fromReport: true
                    };
                    this.$router.push({
                        query: parmas,
                        path: detailComponentUrl
                    });
                } else {
                    // 工程师工作量跳转使用
                    let paramMap = this.paramMap;
                    if(!Utils.isNoB(paramMap.chiefFlag)) {
                        filterItems.chiefFlag = paramMap.chiefFlag;
                    }
                    // 跳转详情参数
                    if(!Utils.isNoB(dataMap)) {
                        // 零售商
                        filterItems.groupName = dataMap.专业分类 || dataMap.groupName || null;
                        filterItems.servicerName = dataMap.服务商 || dataMap.servicerName || '';
                        filterItems.retailerBizUnitName = dataMap.retailerBizUnitName || '';
                        filterItems.retailerShopName = dataMap.retailerShopName || '';
                        filterItems.servcType = dataMap.servcType || 0;
                        filterItems.title = dataMap.title || '';
                        filterItems.shortSpec = dataMap.shortSpec || '';
                        filterItems.brandName = dataMap.brandName || '';
                        filterItems.sellerName = dataMap.sellerName || '';
                        // 服务商
                        filterItems.servicerShopName = dataMap.servicerShopName || dataMap.shopName || '';
                        filterItems.engineerName = dataMap.工程师 || dataMap.engineerName || '';
                        filterItems.phoneNo = dataMap.手机号 || dataMap.phoneNo || '';
                        filterItems.retailerName = dataMap.retailerName || '';
                        filterItems.servcCatName = dataMap.servcCatName || '';
                        filterItems.servcName = dataMap.servcName || '';
                    }
                    // 跳转详情
                    this.$router.push({
                        query: {dataJson: filterItems, colName: colName, queryData: true},
                        path: detailComponentUrl
                    });
                }

            },
            toViewDetail: function (row) {
                // 具体逻辑
                let detailComponentUrl = this.detailComponentUrl;
                if(Utils.isNoB(detailComponentUrl)) {
                    MsgBox.warning("请确定要跳转的详情的url");
                    return;
                }
                //
                let filterItems = this.queryModel.filterItems || {};
                // 跳转详情参数
                if(!Utils.isNoB(row)) {
                    //
                    filterItems.title = row.title || '';
                    filterItems.shortSpec = row.shortSpec || '';
                    filterItems.brandName = row.brandName || '';
                    filterItems.sellerName = row.sellerName || '';
                }
                // 跳转详情
                this.$router.push({
                    query: {dataJson: filterItems, queryData: true},
                    path: detailComponentUrl
                });
            },
            getTableSelection() {
                return this.$refs.result_table.getSelection();
            }
        }
    }
</script>

<style>
    .easyreport {
        width: 100%;
    }

    .easyreport .easyreport-header th, .easyreport .easyreport-header td {
        height: 24px;
        background-color: #308ca5;
        border-right: 1px solid #ccc;
        border-top: none;
        text-align: center;
        color: #fff;
    }

    .easyreport tr:hover td {
        background-color: rgba(254, 245, 194, 0.8) !important;
    }

    .easyreport th, .easyreport td {
        padding: 8px 10px;
        border-right: 1px solid #ccc;
        color: black;
    }

    .easyreport .easyreport-fixed-column {
        background-color: rgba(236, 251, 210, 0.65);
        font-weight: bold;
        font-size: 11px;
        text-align: left;
    }

    .easyreport th {
        background-color: #308ca5;
        border: 1px solid #ccc;
        font-size: 11px;
        color: #fff;
        text-align: center;
        padding: 8px 2px 8px 2px;
    }

    .easyreport td a {
        text-decoration: underline;
        color: black;
    }

    .easyreport td {
        border: 1px solid #ccc;
        text-align: center;
        font-size: 11px;
        height: 18px;
    }

    .designer-table td {
        border: solid 0.1px #e6e6e6
    }

    .designer-table .j-item {
        float: left;
        margin-right: 4px;
        line-height: 25px;
    }

    .pr50 {
        padding-right: 50px
    }

</style>



// WEBPACK FOOTER //
// src/compo/easyReport/EasyReport.vue